import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router";
import { useAnalytics } from "../../../../analytics/analytics";
import { ReleaseNotes } from "../../../../release-notes/release-notes";
import { useSidebar2026 } from "../../../hooks/use-sidebar-2026";
import { AdditionalServicesSection } from "../additional-services-section";
import { ThemeAwareDivider } from "../divider";
import { DebugButton } from "./debug-button/debug-button";
import { NavHeader } from "./nav-header";
import { NavOptions } from "./nav-options";
import { NavPlannerOptions } from "./nav-planner-options";
import { NeedHelp } from "./need-help";
import { WhatsNew } from "./whats-new";

import type { NavigationProps } from "./types";
import type { FC } from "react";

export const Navigation: FC<NavigationProps> = ({ onClose }) => {
  const navigate = useNavigate();
  const { gaEvent } = useAnalytics();
  const sidebar2026 = useSidebar2026();

  return (
    <Stack sx={{ height: "100%" }}>
      <NavHeader onClose={onClose} />

      <Stack component="nav" spacing={2} sx={{ flexGrow: 1, px: 2 }}>
        <Button
          data-analytics-id="sidebar-home"
          fullWidth
          onClick={() => {
            onClose?.();
            gaEvent("multiformat_button", { action: "click", value: "Home" });
            void navigate({ pathname: "/" });
          }}
          variant="contained"
        >
          Home
        </Button>
        <ReleaseNotes />
        <NavOptions onNavigate={onClose} />
        {/* The 2026 sidebar puts Calendar and Timeline in the main list, inside NavOptions. */}
        {!sidebar2026 && (
          <>
            <ThemeAwareDivider />
            <NavPlannerOptions onNavigate={onClose} />
          </>
        )}
        {sidebar2026 ? (
          <>
            {/* Help and What's new sit just under the services band, and Debug below them. The
                band and the row share a Stack of their own, as the nav's spacing can't be undone. */}
            <Stack>
              <AdditionalServicesSection />
              <Stack direction="row" sx={{ justifyContent: "space-between", px: 1, pt: 1, pb: 3 }}>
                <NeedHelp />
                <WhatsNew />
              </Stack>
            </Stack>
            <DebugButton />
          </>
        ) : (
          <>
            <AdditionalServicesSection />
            <DebugButton />
            <Stack direction="row" sx={{ justifyContent: "space-between", px: 1, py: 3 }}>
              <NeedHelp />
              <WhatsNew />
            </Stack>
          </>
        )}
      </Stack>
    </Stack>
  );
};
